import {
    useCreateController,
    CreateContextProvider,
    Form,
    SaveButton,
    useNotify,
    useTranslate,
    useRefresh
} from 'react-admin';

import {
    DialogTitle,
    DialogContent,
    DialogActions,
    Button as MUIButton
} from '@mui/material';

import { Resources } from '../../resource';
import SearchPlaceholderForm from './SearchPlaceholderForm';
import { PermissionButton } from 'src/routes/components/permission-button';

const CreateSearchPlaceholder = ({ onClose }: { onClose: () => void }) => {
    const notify = useNotify();
    const t = useTranslate();
    const refresh = useRefresh();

    const controller = useCreateController({
        resource: Resources.searchPlaceholder,
        mutationOptions: {
            onSuccess: () => {
                notify(t('module.searchPlaceholder.createSuccess'), { type: 'success' });
                refresh()
                onClose()
            },
            onError: (error: any) => {
                const errorCode = error?.body?.code || error?.code;
                switch (errorCode) {
                    
                    default:
                        notify(t('module.searchPlaceholder.unknownError'), { type: 'error' });
                        break;
                }
            }
        }
    });

    return (
        <CreateContextProvider value={controller}>
            <Form disableInvalidFormNotification>
                <DialogTitle>{t("module.searchPlaceholder.create")}</DialogTitle>
                <DialogContent>
                    <SearchPlaceholderForm isCreate />
                </DialogContent>
                <DialogActions>
                    <MUIButton variant="outlined" onClick={onClose}>
                        {t('actions.cancel')}
                    </MUIButton>
                    <PermissionButton resource="search-placeholders" action="create">
                        <SaveButton />
                    </PermissionButton>
                </DialogActions>
            </Form>
        </CreateContextProvider>
    );
};

export default CreateSearchPlaceholder;
